import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  category: PropTypes.any,
  onSave: PropTypes.func,
  onView: PropTypes.func,
  onDelete: PropTypes.func,
};

class EditCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        description: null,
      },
      category: {
        name: '',
        description: '',
        img: '',
      },
      open: false,
      viewRedirect: false,
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let category = nextProps.category;
    if (nextProps.category.id) {
      category = nextProps.category;
    }
    category.id = (category.id === null) ? 0 : category.id;
    this.setState({ category });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const category = this.state.category;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = category[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const category = this.props.category;
    if (e.target.type === 'checkbox') {
      _.set(category, e.target.name, e.target.checked);
    } else {
      _.set(category, e.target.name, e.target.value);
    }
    this.setState({
      category,
      edited: true,
    });
    this.setRequiredParams();
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/categories/view/${this.props.category.id}`);
    }
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Category';
    nextState.dialogMessage = 'Do you really want to delete this category?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/categories/view/${this.state.category.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Category Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this category?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.category.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.category);
        break;
      default:
        this.props.onSave(this.state.category);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/categories?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      wideStyle:{
        marginRight: '2%',
        width: '700px',
      }
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.category.id}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.name}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Tagline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.category.tagline}
            name="tagline"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine={true}
          />
          <TextField
            floatingLabelText="Image Url"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.img || ''}
            name="img"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <br/>
          <TextField
            floatingLabelText="Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.category.description}
            name="description"
            onChange={this.handleChange}
            style={styles.wideStyle}
            errorText={this.state.required.description}
            errorStyle={{ color: cyan500 }}
            multiLine={true}
          />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

EditCategory.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditCategory.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    category: state.categories.category,
  };
}

export default connect(mapStateToProps)(EditCategory);



// WEBPACK FOOTER //
// ./src/components/categories/EditCategory.js